import { createContext, type Context } from 'react';

export const StatusBarTargetContext: Context<HTMLDivElement | null> =
    createContext<HTMLDivElement | null>(null);
